export const ORG_HOURS = {
  timezone: 'Asia/Kolkata',
  openTime: '09:00',
  closeTime: '20:30',
  slotMinutes: 30,
};

export const TABLES = [
  { id: 't1', label: 'T1', capacity: 2, color: '#6B7280', isActive: true },
  { id: 't2', label: 'T2', capacity: 4, color: '#3B82F6', isActive: true },
  { id: 't3', label: 'T3', capacity: 4, color: '#10B981', isActive: true },
  { id: 't4', label: 'T4', capacity: 6, color: '#F59E0B', isActive: true },
  { id: 't5', label: 'T5', capacity: 2, color: '#EF4444', isActive: true },
];

export const RESERVATIONS = [
  {
    id: 'r1',
    customerName: 'Anita M',
    partySize: 2,
    start: '2025-08-23T19:00:00+05:30',
    end: '2025-08-23T20:15:00+05:30',
    tableId: 't2',
    source: 'Website',
    status: 'Confirmed',
    notes: '',
  },
  {
    id: 'r2',
    customerName: 'Rahul S',
    partySize: 4,
    start: '2025-08-23T19:30:00+05:30',
    end: '2025-08-23T21:00:00+05:30',
    tableId: 't4',
    source: 'Phone',
    status: 'CheckedIn',
  },
  {
    id: 'r3',
    customerName: 'Walk-in Hold',
    partySize: 3,
    start: '2025-08-23T20:00:00+05:30',
    end: '2025-08-23T21:00:00+05:30',
    tableId: undefined,
    source: 'WalkIn',
    status: 'Confirmed',
  },
];

export const STATUS_THEME = {
  Confirmed: { bg: 'rgba(59,130,246,0.15)', text: '#1d4ed8', border: '#3b82f6' },
  CheckedIn: { bg: 'rgba(16,185,129,0.15)', text: '#065f46', border: '#10b981' },
  Cancelled: { bg: 'rgba(107,114,128,0.20)', text: '#374151', border: '#9ca3af', strike: true },
  NoShow: { bg: 'rgba(244,63,94,0.15)', text: '#9f1239', border: '#f43f5e', dashed: true },
};